/*!
 * DeLuca Vodka - Big Thirst Headless Config
 * Version: 2026-06-22-02
 *
 * Dedicated Squarespace setup for delucavodka.com.
 * Backend: shared Daisy / checkout-6.
 *
 * Upload this file to checkout-6 Shopify Content > Files.
 *
 * Squarespace setup:
 *   Settings > Developer Tools > Code Injection > Header:
 *   <script src="https://checkout-6.bigthirst.com/cdn/shop/files/deluca-loader.js"></script>
 *
 *   Remove the old footer script that manually creates `.bt-buy-button`.
 *   This config mounts the DeLuca product button on the Squarespace product page.
 *
 * Shopify product:
 *   - Product ID: 10463843647775
 *   - Handle: deluca-vodka
 *   - Vendor: Center Fire Distillery
 */

window.__BT_DELUCA_CONFIG_VERSION = '2026-06-22-02';
console.info('[DeLuca Headless Config]', window.__BT_DELUCA_CONFIG_VERSION);

var DELUCA_PRODUCT_PATH = '/product-1';
var DELUCA_OPEN_CART_PARAM = 'bt-cart';
var DELUCA_OPEN_CART_VALUE = 'open';
var DELUCA_OPEN_CART_STORAGE_KEY = 'bt:deluca:open-cart';

window.BigThirstCartConfig = {
  domain: 'checkout-6.bigthirst.com',
  apiVersion: '2026-01',

  // Single-product button
  buyButtonText: 'Add to Cart',

  // Keep the product page clean. The button still switches to Sold Out if unavailable.
  showInventory: false,
  inventorySoldOutText: 'Sold Out',

  // Cart copy
  checkoutButtonText: 'Begin Checkout',
  cartNotice: 'All sales processed by retail partners of<br><strong>Big Thirst, Inc.</strong><br>Tax &amp; shipping calculated in next window.<br>Questions? <a href="mailto:help@bigthirst.com">help@bigthirst.com</a>',
  cartNoteSublabel: 'Discounts/Promo Codes Added During Checkout',
  cartNoteLabel: 'Order Note',
  cartNotePrefix: '-------Discounts/Promo Codes Added During Checkout----------------------Powered by Shop.BigThirst.com----------------',

  // Typography mirrors the live Squarespace theme.
  googleFonts: 'https://fonts.googleapis.com/css2?family=Manrope:wght@500;700&family=Nunito+Sans:wght@400;700&display=swap',

  cssVars: [
    '--bt-font: "Nunito Sans", Arial, sans-serif;',
    '--bt-alt-font: "Manrope", Arial, sans-serif;',
    '--bt-text-color: #000000;',
    '--bt-price-color: #000000;',
    '--bt-price-size: 22px;',
    '--bt-title-size: 24px;',
    '--bt-title-weight: 700;',
    '--bt-title-margin: 8px;',
    '--bt-title-min-height: auto;',
    '--bt-border-color: #303030;',
    '--bt-btn-bg: #303030;',
    '--bt-btn-color: #ffffff;',
    '--bt-btn-hover-bg: #000000;',
    '--bt-btn-hover-color: #ffffff;',
    '--bt-btn-px: 28px;',
    '--bt-btn-radius: 999px;',
    '--bt-qty-size: 16px;',
    '--bt-add-btn-size: 16px;',
    '--bt-toggle-icon-color: #ffffff;',
    '--bt-toggle-count-color: #ffffff;',
    '--bt-notice-bold-color: #000000;',
    '--bt-notice-link-color: #303030;',
  ].join(' '),

  customCSS: [
    '.productDetails .product-price.bt-deluca-native-hidden, .productDetails .product-purchase-controls-wrapper.bt-deluca-native-hidden {',
    '  display: none !important;',
    '}',
    '.bt-buy-button, .bt-buy-button .bt-embed {',
    '  width: 100%;',
    '  max-width: 420px;',
    '  margin: 0;',
    '  text-align: left;',
    '}',
    '.bt-buy-button .bt-embed {',
    '  padding: 0;',
    '}',
    '.bt-buy-button .bt-embed-price {',
    '  color: #000000 !important;',
    '  font-family: "Manrope", Arial, sans-serif !important;',
    '  font-size: 22px !important;',
    '  font-weight: 700 !important;',
    '  line-height: 1.2 !important;',
    '  margin: 0 0 18px !important;',
    '  text-align: left;',
    '}',
    '.bt-buy-button .bt-qty-wrap {',
    '  justify-content: flex-start !important;',
    '  margin: 0 0 18px !important;',
    '}',
    '.bt-buy-button .bt-qty-btn, .bt-buy-button .bt-qty-input {',
    '  background: #ffffff !important;',
    '  border-color: #303030 !important;',
    '  color: #000000 !important;',
    '  font-family: "Nunito Sans", Arial, sans-serif !important;',
    '  height: 44px !important;',
    '}',
    '.bt-buy-button .bt-qty-btn {',
    '  width: 44px !important;',
    '  border-radius: 999px !important;',
    '}',
    '.bt-buy-button .bt-qty-input {',
    '  width: 56px !important;',
    '  border-left: none !important;',
    '  border-right: none !important;',
    '  border-radius: 0 !important;',
    '}',
    '.bt-buy-button .bt-add-btn {',
    '  align-items: center;',
    '  background: #303030 !important;',
    '  border: 1px solid #303030 !important;',
    '  border-radius: 999px !important;',
    '  box-shadow: none !important;',
    '  color: #ffffff !important;',
    '  display: inline-flex !important;',
    '  font-family: "Manrope", Arial, sans-serif !important;',
    '  font-size: 16px !important;',
    '  font-weight: 700 !important;',
    '  justify-content: center;',
    '  letter-spacing: 0;',
    '  line-height: 1 !important;',
    '  min-height: 56px;',
    '  padding: 0 32px !important;',
    '  text-align: center;',
    '  text-transform: none;',
    '  width: min(100%, 360px) !important;',
    '}',
    '.bt-buy-button .bt-add-btn:hover, .bt-buy-button .bt-add-btn:focus {',
    '  background: #000000 !important;',
    '  border-color: #000000 !important;',
    '  color: #ffffff !important;',
    '  opacity: 1 !important;',
    '  outline: none !important;',
    '}',
    '#bt-cart-toggle {',
    '  background: #303030 !important;',
    '  border: 1px solid #303030 !important;',
    '  border-radius: 999px !important;',
    '  bottom: 20px !important;',
    '  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.22) !important;',
    '  color: #ffffff !important;',
    '  right: 20px !important;',
    '}',
    '#bt-cart-toggle:hover, #bt-cart-toggle:focus {',
    '  background: #000000 !important;',
    '  border-color: #000000 !important;',
    '  opacity: 1 !important;',
    '}',
    '#bt-cart-drawer, #bt-cart-drawer * {',
    '  font-family: "Nunito Sans", Arial, sans-serif !important;',
    '}',
    '#bt-cart-drawer .bt-cart-title, #bt-cart-drawer .bt-checkout-btn {',
    '  font-family: "Manrope", Arial, sans-serif !important;',
    '}',
    '#bt-cart-drawer .bt-checkout-btn {',
    '  background: #303030 !important;',
    '  border-color: #303030 !important;',
    '  border-radius: 999px !important;',
    '  color: #ffffff !important;',
    '  letter-spacing: 0;',
    '  text-transform: none;',
    '}',
    '#bt-cart-drawer .bt-checkout-btn:hover, #bt-cart-drawer .bt-checkout-btn:focus {',
    '  background: #000000 !important;',
    '  border-color: #000000 !important;',
    '  color: #ffffff !important;',
    '  opacity: 1 !important;',
    '}',
    '@media (max-width: 640px) {',
    '  .bt-buy-button, .bt-buy-button .bt-embed { max-width: 100%; }',
    '  .bt-buy-button .bt-add-btn { width: 100% !important; }',
    '}',
  ].join('\n'),
};

function isDeLucaProductPage() {
  return /\/product(\/|$)/.test(window.location.pathname) ||
    /deluca-750ml-premium-vodka/.test(window.location.pathname) ||
    !!document.querySelector('.productDetails, .ProductItem-details, .pdp-details, [data-section-id] .product-details');
}

function isNativeSquarespaceCartPage() {
  return /^\/cart\/?$/.test(window.location.pathname);
}

function getDeLucaProductUrl(openCart) {
  var url = new URL(DELUCA_PRODUCT_PATH, window.location.origin);
  if (openCart) url.searchParams.set(DELUCA_OPEN_CART_PARAM, DELUCA_OPEN_CART_VALUE);
  return url.toString();
}

function markDeLucaOpenCartIntent() {
  try {
    window.sessionStorage.setItem(DELUCA_OPEN_CART_STORAGE_KEY, '1');
  } catch (e) {}
}

function hasDeLucaOpenCartIntent() {
  try {
    if (window.sessionStorage.getItem(DELUCA_OPEN_CART_STORAGE_KEY) === '1') return true;
  } catch (e) {}

  try {
    return new URLSearchParams(window.location.search).get(DELUCA_OPEN_CART_PARAM) === DELUCA_OPEN_CART_VALUE;
  } catch (e) {
    return false;
  }
}

function clearDeLucaOpenCartIntent() {
  try {
    window.sessionStorage.removeItem(DELUCA_OPEN_CART_STORAGE_KEY);
  } catch (e) {}

  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get(DELUCA_OPEN_CART_PARAM) === DELUCA_OPEN_CART_VALUE) {
      url.searchParams.delete(DELUCA_OPEN_CART_PARAM);
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    }
  } catch (e) {}
}

function redirectNativeSquarespaceCartPage() {
  if (!isNativeSquarespaceCartPage()) return false;
  markDeLucaOpenCartIntent();
  window.location.replace(getDeLucaProductUrl(true));
  return true;
}

function openDeLucaCartWhenReady(attempt) {
  if (!hasDeLucaOpenCartIntent()) return;

  if (
    window.BigThirstCart &&
    typeof window.BigThirstCart.openCart === 'function' &&
    document.getElementById('bt-cart-drawer')
  ) {
    clearDeLucaOpenCartIntent();
    window.BigThirstCart.openCart();
    return;
  }

  if (attempt < 80) {
    window.setTimeout(function () {
      openDeLucaCartWhenReady(attempt + 1);
    }, 100);
  }
}

function isNativeCartLink(link) {
  if (!link || !link.href) return false;

  try {
    var url = new URL(link.href, window.location.origin);
    return url.origin === window.location.origin && /^\/cart\/?$/.test(url.pathname);
  } catch (e) {
    return false;
  }
}

function bindNativeCartLinks() {
  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('a[href]') : null;
    if (!isNativeCartLink(link)) return;

    event.preventDefault();
    markDeLucaOpenCartIntent();

    if (window.BigThirstCart && typeof window.BigThirstCart.openCart === 'function') {
      openDeLucaCartWhenReady(0);
      return;
    }

    if (!isDeLucaProductPage()) {
      window.location.assign(getDeLucaProductUrl(true));
      return;
    }

    openDeLucaCartWhenReady(0);
  }, true);
}

function ensureDeLucaProductButton() {
  if (!isDeLucaProductPage()) return;

  var productDetails = document.querySelector(
    '.productDetails, .ProductItem-details, .pdp-details, [data-section-id] .product-details'
  );

  if (!productDetails) return;

  var existing = productDetails.querySelector('.bt-buy-button[data-handle="deluca-vodka"]') ||
    document.querySelector('.bt-buy-button[data-handle="deluca-vodka"]');
  var button = existing || document.createElement('div');

  button.className = button.className
    ? button.className + ' bt-deluca-auto-button'
    : 'bt-buy-button bt-deluca-auto-button';
  button.setAttribute('data-handle', 'deluca-vodka');
  button.setAttribute('data-button-text', 'Add to Cart');
  button.setAttribute('data-bt-deluca-primary', 'true');

  var price = productDetails.querySelector('.product-price, .ProductItem-details-price, .sqs-money-native');
  var controls = productDetails.querySelector('.product-purchase-controls-wrapper, .ProductItem-details-checkout');
  var target = controls || price;

  if (price) price.classList.add('bt-deluca-native-hidden');
  if (controls) controls.classList.add('bt-deluca-native-hidden');

  if (!existing) {
    if (target && target.parentNode) {
      target.parentNode.insertBefore(button, target);
    } else {
      productDetails.appendChild(button);
    }
  }

  dedupeDeLucaButtons();
}

function dedupeDeLucaButtons() {
  var buttons = document.querySelectorAll('.bt-buy-button[data-handle="deluca-vodka"]');

  buttons.forEach(function (button, index) {
    if (index === 0) {
      button.setAttribute('data-bt-deluca-primary', 'true');
      return;
    }
    if (!button.closest('.bt-embed')) button.remove();
  });
}

function watchForDuplicateDeLucaButtons() {
  if (!window.MutationObserver || !document.body) return;

  var observer = new MutationObserver(dedupeDeLucaButtons);
  observer.observe(document.body, { childList: true, subtree: true });

  window.setTimeout(function () {
    observer.disconnect();
    dedupeDeLucaButtons();
  }, 8000);
}

function loadDeLucaCartEngine() {
  if (window.__BT_DELUCA_ENGINE_SCRIPT_ADDED) return;
  window.__BT_DELUCA_ENGINE_SCRIPT_ADDED = true;

  var s = document.createElement('script');
  s.src = 'https://checkout-6.bigthirst.com/cdn/shop/files/bigthirst-cart.js?v=20260622-01';
  s.async = true;
  document.head.appendChild(s);
}

function initDeLucaHeadless() {
  ensureDeLucaProductButton();
  bindNativeCartLinks();
  watchForDuplicateDeLucaButtons();
  loadDeLucaCartEngine();
  openDeLucaCartWhenReady(0);
}

if (redirectNativeSquarespaceCartPage()) {
  // Handled by redirect.
} else if (document.body) {
  initDeLucaHeadless();
} else {
  document.addEventListener('DOMContentLoaded', initDeLucaHeadless);
}
